export default {
  HALF_DAY: 1,
  DAY: 2,
  WEEK: 3,
  MONTH: 4,
  YEAR: 5,
  GLOBAL: 6,
};
